module.exports = __webpack_public_path__ + "static/media/img_bg3@2x.c2d05f79.png";